import React, { Component , Profiler} from 'react';
import '../SideDraw/TaskContext.css';
import './Workplace.css';

import FetchData from '../../Utils/FetchData';
import DXData from '../../Utils/js-bridge/DXData';
import task from '../../../images/icons/task.png';
import folder from '../../../images/icons/folder.png';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import DataGrid, { Scrolling, HeaderFilter, Selection, Column, ColumnFixing, Grouping, Pager, Paging, SearchPanel, GroupPanel, Export, FilterRow, Sorting, } from 'devextreme-react/data-grid';
import { TabPanel, Item } from "devextreme-react/tab-panel";
import { Button } from 'devextreme-react';
import WorkplaceClipboard from '../WorkPlace/WorkplaceClipboard';
import UpdateWorkplace from '../WorkPlace/UpdateWorkplace';
import ActionsTA from '../WorkPlace/actionsTA';
import DashboardList from '../WorkPlace/DashboardList';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import setStateAction from '../../../actions/setStateAction';
import setCurrentObjectId from '../../../actions/setCurrentObjectId';
import setCurrentObject from '../../../actions/setCurrentObject';
import setActionMessage from '../../../actions/setActionMessage';
import setActionDashboardlist from '../../../actions/setActionDashboardlist';
import setCurrentFooterAction from '../../../actions/setActionFooter';
import setActionFolderNotifications from '../../../actions/setActionFolderNotifications';
import setActionTaskNotifications from '../../../actions/setActionTaskNotifications';
import setActionRemoveTab from '../../../actions/setActionRemoveTab';
import { setSelectedContextItemsAction, setSelectedContextId } from '../../../actions/setSelectedContextItemsAction'
import setActionisrootSelected from '../../../actions/setActionisrootSelected'
import setActionTaskContextExpColaps from '../../../actions/setActionTaskContextExpColaps'
import setActionFolderExpColaps from '../../../actions/setActionFolderExpColaps'
import setActionTabs from '../../../actions/setActionTabs'
import SvgEllipse from '../../../iconComponents/iconEllipse';
import SvgQRIcon from '../../../iconComponents/qrIcon';
import * as open from "../../../images/icons/open.svg";
import * as remove from "../../../images/icons/Remove.svg";


import notify from 'devextreme/ui/notify';
import { connect } from 'react-redux';
const pako = require('pako');
const zlib = require('zlib');
var modal;
var taskName;
var taskname;
var currRow;
var Tabs = []
var windowSize
var urlstate = false


 
class WorkPlace extends React.Component {
    constructor(props) {

        //window.addEventListener('keydown', (event) => {
        //   console.log('PROTOS')
        //});
       
        super(props);

        //this.handler = this.handler.bind(this);
        var selectedContextIds = this.props.contextSelectionState === undefined ? undefined : this.props.contextSelectionState === null ? null : this.props.contextSelectionState.map(item => item.id)
        this.state = {
            ViewDataPresentationConditions: [],
            ViewData: [],
            ViewColumns: [],
            ContextSelection: selectedContextIds,
            Tabs: [],
            currentTabIdx: 0,
            changeTab: false,
            keyExpr: 'id',
            pagingDatagrid: false,
            ViewDataConfigurationNoduplicates: '',
            ViewDataView: '',
            windowSize: window.innerWidth,
            windowSizeHeight: window.innerHeight,
            ViewDataViewDocumentPath: '',
            urlIframe:false
          

        };
      
        this.changeResizingMode = this.changeResizingMode.bind(this);
        this.onRowPrepared = this.onRowPrepared.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.customizeText = this.customizeText.bind(this);
        this.gridRef = React.createRef();
        //this.error = this.error.bind(this);
        if (this.props.windowpopupState === 'elapamere') {
           
            this.getFolderDataNofilter()
        }

        if (this.props.folderIdState !== undefined) {
            this.getFolderConfiguration()
            var newTab = {
                display: this.props.folderNameState,
                state: this.props.reduxState
            }

            this.state.Tabs = [newTab]

        }
        if (this.props.contextConfig !== undefined) {

            if (this.props.contextConfig.contextCount === 0) {

                this.getFolderDataNofilter()
            }

        }

        if (this.props.contextSelectionState !== undefined) {
          
            this.getFolderData()

        }
        if (this.props.multirootContext === true) {
            this.getFolderDataNofilter()
        }


    }
   

    handleResize = () => this.setState({
        windowSize: window.innerWidth,
        windowSizeHeight: window.innerHeight,
       
    });
    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
        window.addEventListener('storage', () => {

            if (localStorage.getItem('rememberMe') === 'refreshWorkplace') {
              
                this.props.currObjectSet(undefined)
                this.getFolderData()
                this.getFolderDataNofilter()
                localStorage.setItem('rememberMe', 'notrefreshWorkplace');
            }
        });




        this.props.actionTaskContextExpandCollapse(true)
        this.props.actionFolderExpandCollapse(true)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    componentDidUpdate(prevProps) {
      
        if (this.props.dashboardlist === undefined) {
            modal = document.getElementById("Modal");
            modal.style.display = "none";
        }
        if (this.props.dashboardlist !== undefined) {
            if (this.props.dashboardlist.length > 1) {
                modal = document.getElementById("Modal");
                var span = document.getElementsByClassName("close")[0];
                var button = document.getElementsByClassName("Modal100-form-btn")[0]
                modal.style.display = "block";
                span.onclick = function () {
                    modal.style.display = "none";
                }
                button.onclick = function () {
                    modal.style.display = "none";
                }
                window.onclick = function (event) {
                    if (event.target == modal) {
                        modal.style.display = "none";
                    }
                }
            }
        }
        var widthResolution = window.innerWidth
        if (widthResolution === 1776) {
            document.getElementById("main").style.marginTop = "-30px";
        }
        if (widthResolution === 1920) {
            document.getElementById("main").style.marginTop = "-15px";
        }
        if (this.props.taskcontextExpandCollapse === false) {
            document.getElementById("mySidenav").style.width = "100px";
            document.getElementById("main").style.marginRight = "100px";
            document.getElementById('btnMenu').style.visibility = 'visible';
            document.getElementById('btnMenu').style.marginTop = '-40px';
        }
        if (this.props.taskcontextExpandCollapse === true) {
            document.getElementById("mySidenav").style.width = "360px";
            document.getElementById("main").style.marginRight = "360px";
            document.getElementById('btnMenu').style.visibility = 'visible';
            document.getElementById('btnMenu').style.marginTop = '-40px';
        }
        if (this.props.actionMessage === "Ok" && this.props.actionMessage !== null) {
            if (this.props.contextConfig.contextCount === 0) {
                this.getFolderDataNofilter()
                this.props.actionMessageset(null)
            }
            if (this.props.contextSelectionState !== undefined) {
               
                this.getFolderData()
                this.props.actionMessageset(null)
            }
        }

        if (this.props.currentObjectIdState !== undefined && this.props.currentObjectIdState !== []) {
            if (this.gridRef.current !== null) {
               
                this.gridRef.current.instance.selectRows(this.props.currentObjectIdState, false)
                this.gridRef.current.instance.option('focusedRowKey', this.props.currentObjectIdState[0])
            }
        }

        if (prevProps.folderNameTabs !== this.props.folderNameTabs) {
         
            var tab = this.state.Tabs[0]
            tab.display = this.props.folderNameTabs
            this.setState({ Tabs: [tab] })
        }

        if (prevProps.folderIdState !== this.props.folderIdState) {
           
            this.setState({
                ViewData: [],
            })
            if (this.gridRef.current !== null) {
                this.gridRef.current.instance.clearSelection()
            }
            if (this.props.folderIdState !== undefined) {
                var newTab = {
                    display: this.props.folderNameState,
                    state: this.props.reduxState
                }
                var tabs
                var idx = 0
                if (this.state.Tabs !== undefined) {

                    tabs = this.state.Tabs
                    if (tabs.some(tb => tb.display === this.props.folderNameState)) {
                        idx = tabs.findIndex(tb => tb.display === this.props.folderNameState)
                    } else {
                        tabs.unshift(newTab)
                    }
                } else {
                    tabs = [newTab]
                }
                this.setState({
                    Tabs: tabs,
                    currentTabIdx: idx
                })
            }

            this.getFolderConfiguration()
            if (this.props.contextConfig !== undefined) {
                if (this.props.contextConfig.contextCount !== undefined) {

                    if (this.props.contextConfig.contextCount === 0) {

                        this.getFolderDataNofilter()

                    }
                    if (this.props.contextSelectionState !== undefined) {
                       
                        this.getFolderData()
                    }
                }
            }

        }
        if (prevProps.reduxState !== this.props.reduxState) {
            if (this.state.Tabs !== undefined && this.state.Tabs.length > 0) {
                if (!this.state.changeTab) {
                    if (this.state.Tabs[this.state.currentTabIdx].state.taskDataId === this.props.taskIdState

                        && this.state.Tabs[this.state.currentTabIdx].state.taskDataName === this.props.taskNameState
                        && this.state.Tabs[this.state.currentTabIdx].state.directoryDataId === this.props.directoryIdState
                        && this.state.Tabs[this.state.currentTabIdx].state.directoryDataName === this.props.directoryNameState
                        && this.state.Tabs[this.state.currentTabIdx].state.folderDataId === this.props.folderIdState
                        && this.state.Tabs[this.state.currentTabIdx].state.folderDataName === this.props.folderNameState) {

                      
                        // Comment out this line of code  because some time the navigation between tabs not change folder state . 
                         this.state.Tabs[this.state.currentTabIdx].state = this.props.reduxState
                       //  Comment out this line of code  because some time the navigation between tabs not change folder state . 
                    }

                }
            }
        }
        if (prevProps.taskIdState !== this.props.taskIdState) {

            this.setState({
                ViewColumns: [],
                ViewDataConfigurationNoduplicates: []
            })
        }

        if (prevProps.roledataId !== this.props.roledataId && prevProps.roledataId != this.props.roledataId) {
          
            this.props.actionFolderNotificationset(undefined)
            this.props.currTaskNotificationStateSet(undefined)
            this.props.contextSelectionSet(undefined)
            this.props.contextSelectionState
            this.setState({
                Tabs: [],
                ViewColumns: [],
                ViewDataConfigurationNoduplicates: []
            })
        }
      
        if ((prevProps.contextSelectionState !== this.props.contextSelectionState || prevProps.contextSelectionIdState !== this.props.contextSelectionIdState) && this.props.contextSelectionState !== null) {
           
            if (this.props.rootContextState === '00000000-0000-0000-0000-000000000000') {
               
                if (this.state.ViewDataView === 2) {
                
                    this.getFolderData()
                } else {
                 
                    if (this.props.rootSelectedState === true) {
                     
                        this.getFolderDataNofilter()
                    }
                    if (this.props.rootSelectedState === false) {
                    
                        this.getFolderData()
                    }
                }
            } else if (this.props.rootContextState !== '00000000-0000-0000-0000-000000000000') {
              
                this.getFolderData()
            }
            else if (this.props.rootContextState === undefined) {
              
                this.getFolderData()
            }

        }

        if ((prevProps.contextTemplateIdState !== this.props.contextTemplateIdState || this.props.contextSelectionState === null) && (this.state.changeTab === false )) {
           
            this.props.contextSelectionSet(undefined)
            this.setState({ ViewData: [] })
        }

    }
    customizeText = (cellInfo) => {

        return cellInfo.valueText !== null ? cellInfo.valueText : ''
    }
    getFolderConfiguration() {


        if (this.props.folderIdState === undefined) {
            this.setState({
                ViewDataPresentationConditions: [],
                ViewColumns: []
            })
        }
        this.props.indicatorVisible(true)
        FetchData('/api/RTFCW/FolderViewConfigurationPlusUserSettingsA/' + this.props.folderIdState + '/' + this.props.usedataState)
            .then((data) => {
               
                this.setState({
                    ViewDataView: data.data.ViewData_View.queryType,
                    ViewDataViewDocumentPath: data.data.ViewData_View.documentPath
                   // ViewDataViewDocumentPath: 'https://www.msn.com'
                })
                //if (this.state.ViewDataViewDocumentPath !== null && this.state.ViewDataViewDocumentPath !== '') {
                //    console.log('this.state.ViewDataViewDocumentPath')
                //    console.log(this.state.ViewDataViewDocumentPath)
                //    window.open(this.state.ViewDataViewDocumentPath, "_blank")
                //}
               
              
                //if (this.state.ViewDataViewDocumentPath !== null && this.state.ViewDataViewDocumentPath !== '') {
                //    var lastChar = this.state.ViewDataViewDocumentPath.substr(this.state.ViewDataViewDocumentPath.length - 4);

                //    if (lastChar === '.vbd') {
                //        console.log('1')

                //        urlstate = false

                //    } else {
                //        console.log('2')
                //        window.open(data.data.ViewData_View.documentPath, "_blank")
                //        urlstate = true


                //    }
                //} else {
                //    console.log('3')
                //    urlstate = false

                //}
                if (data.data.ViewData_Configuration === null || data.data.ViewData_Configuration.length === 0) {
                
                    this.gridRef.current.instance.option('columns', null)
                    this.setState({ ViewColumns: [] })
                    this.props.indicatorVisible(false)
                } else {

                    this.setState({ ViewDataConfigurationNoduplicates: data.data.ViewData_Configuration })
                    var ViewDataConfigurationNoduplicates = data.data.ViewData_Configuration.filter((elem, index, self) => self.findIndex(
                        (t) => { return (t.alias === elem.alias) }) === index)
                    var columnOrder
                    var columnSort
                    var columnGroup
                    var columndisplayOrder
                    if (data.data.ViewData_UserSettings === null || data.data.ViewData_UserSettings.length == 0) {
                        columnOrder = null
                        columnSort = null
                        columnGroup = null
                        columndisplayOrder = null
                    } else {
                        columnOrder = data.data.ViewData_UserSettings[0].columnKey === null ? null : data.data.ViewData_UserSettings[0].columnKey.split('\t')
                        columnSort = data.data.ViewData_UserSettings[0].sortedColumn === null ? null : data.data.ViewData_UserSettings[0].sortedColumn.split('\t')
                        columnGroup = data.data.ViewData_UserSettings[0].groupedColumn === null ? null : data.data.ViewData_UserSettings[0].groupedColumn.split('\t')
                        columndisplayOrder = data.data.ViewData_UserSettings[0].columnDisplayOrder === null ? null : data.data.ViewData_UserSettings[0].columnDisplayOrder.split('\t')

                       
                    }
                    var checkDatafield = ViewDataConfigurationNoduplicates.find(nameid => nameid.name === 'id')
                    if (checkDatafield === undefined) {
                        ViewDataConfigurationNoduplicates.unshift({ name: "id", alias: 'id' });
                    }
                    var columns = ViewDataConfigurationNoduplicates.map((item) => {

                        if (item.hidden === false) {
                            var position = columnOrder === null ? item.ordinalPosition : columndisplayOrder[columnOrder.findIndex(i => i.toLowerCase() === item.name.toLowerCase())]
                            var sort = undefined
                            if (columnSort === null) {
                                if (item.sorting === 1) {
                                    sort = 'desc'
                                }
                                else if (item.sorting === 0) {
                                    sort = 'asc'
                                } else {
                                    sort = undefined
                                }
                            } else {
                                var idx = columnSort.findIndex(i => i.toLowerCase() === item.name.toLowerCase())
                                if (idx >= 0) {

                                    sort = columnSort[idx + 1] == 0 ? 'desc' : 'asc'

                                } else {
                                    sort = undefined
                                }
                            }

                            var groupby = columnGroup === null ? item.groupOrder : columnGroup.findIndex(i => i.toLowerCase() === item.name.toLowerCase())

                            var dataType
                           
                            switch (item.type) {
                                case 1:
                                    dataType = 'number'
                                    break;
                                case 2:
                                    dataType = 'date'

                                    break;
                                case 3:
                                    dataType = 'boolean'
                                    break;
                                case 6:
                                    dataType = 'datetime'
                                    break;
                                default:
                                    dataType = ''

                            }
                            if (groupby > -1) {

                                return <Column allowFixing={true} customizeText={this.customizeText} visibleIndex={position === undefined ? item.ordinalPosition : position} groupIndex={groupby} caption={item.alias === "" ? item.name : item.alias} dataField={item.name.toLowerCase()} dataType={dataType} />
                            } else {

                                return <Column allowFixing={true} customizeText={this.customizeText} visibleIndex={position === undefined ? item.ordinalPosition : position} caption={item.alias === "" ? item.name : item.alias} dataField={item.name.toLowerCase()} sortOrder={sort} dataType={dataType} />
                            }
                        } else {

                            return <Column allowFixing={true} customizeText={this.customizeText} caption={item.alias === "" ? item.name : item.alias} dataField={item.name.toLowerCase()} visible={false} />
                        }
                    })
                    this.setState({
                        ViewDataPresentationConditions: data.data.ViewData_PresentationConditions,
                        ViewColumns: columns
                    })

                    this.props.indicatorVisible(false)
                }
            }).catch(function (error) {
                this.props.indicatorVisible(false)
                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            }.bind(this));
    }
    getFolderDataNofilter() {
       
      

        var postparameters = "{'parameters':[\
                        {'name':'<CURRENTUSER>','value':'"+ this.props.usedataState + "','pType':'i' },\
                        {'name':'<CURRENTTASK>','value':'"+ this.props.taskIdState + "','pType':'i' },\
                        {'name':'<CURRENTROLE>','value':'"+ this.props.roledataId + "','pType':'i' },\
                        ]}";

        this.props.actionDashboardlistset(undefined)
        this.props.indicatorVisible(true)
        FetchData('/api/RTFCW/FolderViewDataA/' + this.props.folderIdState, 'POST', postparameters)
        //FetchData('/api/RTFCW/FolderViewDataA/956b94f8-337f-466f-a126-b8028c2c96e7', 'POST', postparameters)
            .then(response => {
                if (response.messages[0] == 'SCRIPT TYPE (VBSCRIPT) IS NOT YET SUPPORTED.' ||
                    response.messages[1] == 'SCRIPT TYPE (VBSCRIPT) IS NOT YET SUPPORTED.') {
                    modal = document.getElementById("myModal");
                    // Get the <span> element that closes the modal
                    var span = document.getElementsByClassName("close")[0];
                    // When the user clicks the button, open the modal 
                    modal.style.display = "block";
                    // When the user clicks on <span> (x), close the modal
                    span.onclick = function () {
                        modal.style.display = "none";
                    }
                    // When the user clicks anywhere outside of the modal, close it
                    window.onclick = function (event) {
                        if (event.target == modal) {
                            modal.style.display = "none";
                        }
                    }
                }

                var viewData = response.data
              

                //if (!Array.isArray(viewData)) {
                //    viewData = JSON.parse(response.data)
                //}
                //var joined
                //console.log(DXData())
                //if (DXData().length > 0 && response.data.length > 0) {
                   
                //    joined = viewData.concat(DXData());
                //} else {
                   
                //    joined = viewData;
                //}
                //var objViewData = joined.map(function (item) {
                //    for (var key in item) {
                //        item[key.toLowerCase()] = item[key];
                //    }
                //    return item;
                //})


                // new call after stavros changes to improve perfomance
                var objViewData
                if (viewData.stream !== undefined) {
                    var compressedBuffer = Buffer.from(viewData.data, 'base64');
                    zlib.gunzip(compressedBuffer, (error, decompressedBuffer) => {
                        if (error) {
                            console.error('Error while decompressing:', error);
                            return;
                        }

                        const decompressedString = decompressedBuffer.toString('utf8');

                        //if (decompressedString !== null) {

                            try {
                                // if jQuery
                                objViewData = JSON.parse(decompressedString).map(function (item) {
                                    for (var key in item) {

                                        item[key.toLowerCase()] = item[key];
                                    }
                                    return item;
                                })

                                this.setState({
                                    ViewData: objViewData,
                                    keyExpr: Object.keys(objViewData[0])[0]
                                })
                            }
                            catch (e) {

                            }

                          
                        //}
                       

                    });
                } else {
                    if (!Array.isArray(viewData)) {
                        viewData = JSON.parse(response.data)
                    }
                    objViewData = viewData.map(function (item) {
                        for (var key in item) {
                            item[key.toLowerCase()] = item[key];
                        }
                        return item;
                    })
                    this.setState({
                        ViewData: objViewData,
                        // ViewData: joined,
                        keyExpr: Object.keys(objViewData[0])[0]
                    })
                }

                this.props.indicatorVisible(false)

            }).catch(function (error) {


                this.props.indicatorVisible(false)


                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            }.bind(this));
    }
    getFolderData() {

        if (this.props.rootSelectedState === true) {
            if (this.props.contextSelectionState === undefined) {
              
                this.setState({ ViewData: [] })
                this.props.contextSelectionSet(undefined)
            }

            if (this.props.contextSelectionState !== undefined && this.props.contextSelectionState !== null) {
               
                var contextSelection
                var contextRoots
                var contextParents


                if (this.props.rootContextState === '00000000-0000-0000-0000-000000000000' || this.props.rootContextState === undefined) {
                    
                    contextSelection = '00000000-0000-0000-0000-000000000000'
                    contextRoots = '00000000-0000-0000-0000-000000000000'
                    contextParents = '00000000-0000-0000-0000-000000000000'
                }
                else {
                    if (this.props.contextSelectionState !== '00000000-0000-0000-0000-000000000000' || this.props.contextSelectionState !== undefined) {
                        contextSelection = this.props.contextSelectionState.map((c) => '{' + c.id + '}:{' + c.beid + '}').join(',')
                        contextRoots = this.props.contextSelectionState.map((c) => c.root).join(':')
                        contextParents = this.props.contextSelectionState.map((c) => c.parent).join(':')


                    }
                }
              
                var postparameters = "{'parameters':[\
                        {'name':'<CURRENTUSER>','value':'"+ this.props.usedataState + "','pType':'i' },\
                        {'name':'<CURRENTTASK>','value':'"+ this.props.taskIdState + "','pType':'i' },\
                        {'name':'<CURRENTROLE>','value':'"+ this.props.roledataId + "','pType':'i' },\
                        {'name':'<USERCONTEXTTEMPLATE>','value':'"+ this.props.contextTemplateIdState + "','pType':'as' },\
                        {'name':'<USERROOTCONTEXTSELECTION>','value': '"+ contextRoots + "','pType':'as' },\
                        {'name':'<USERPARENTCONTEXTSELECTION>','value': '"+ contextParents + "','pType':'as' },\
                        {'name':'<USERCONTEXTSELECTION>', 'value': '"+ contextSelection + "', 'pType': 'as' } \
                    ]}";
                this.props.indicatorVisible(true)

                FetchData('/api/RTFCW/FolderFilteredDataA/' + this.props.folderIdState, 'POST', postparameters)
               
                    .then(data => {

                        if (data.messages[0] == 'SCRIPT TYPE (VBSCRIPT) IS NOT YET SUPPORTED.' ||
                            data.messages[1] == 'SCRIPT TYPE (VBSCRIPT) IS NOT YET SUPPORTED.') {
                            modal = document.getElementById("myModal");
                            // Get the <span> element that closes the modal
                            var span = document.getElementsByClassName("close")[0];
                            // When the user clicks the button, open the modal 
                            modal.style.display = "block";
                            // When the user clicks on <span> (x), close the modal
                            span.onclick = function () {
                                modal.style.display = "none";
                            }
                            // When the user clicks anywhere outside of the modal, close it
                            window.onclick = function (event) {
                                if (event.target == modal) {
                                    modal.style.display = "none";
                                }
                            }
                        }

                        //const compressedBuffer = Buffer.from(data.data.data, 'base64');

                        var objViewData
                        if (data.data.stream !== undefined) {
                            var compressedBuffer = Buffer.from(data.data.data, 'base64');
                            zlib.gunzip(compressedBuffer, (error, decompressedBuffer) => {
                                if (error) {
                                    console.error('Error while decompressing:', error);
                                    return;
                                }

                                const decompressedString = decompressedBuffer.toString('utf8');

                                //if (JSON.parse(decompressedString).ViewData !== null) {
                                    objViewData = JSON.parse(decompressedString).ViewData.map(function (item) {
                                        for (var key in item) {

                                            item[key.toLowerCase()] = item[key];
                                        }
                                        return item;
                                    })

                                    if (objViewData.length > 0) {
                                        if (this.gridRef.current.instance.columnOption(Object.keys(objViewData[0])[0]) === undefined) {
                                            this.gridRef.current.instance.addColumn(Object.keys(objViewData[0])[0], 'Data Field', Object.keys(objViewData[0])[0], 'Caption', Object.keys(objViewData[0])[0], 'visible', "false")
                                        }
                                        this.setState({

                                            ViewData: objViewData,

                                            keyExpr: Object.keys(objViewData[0])[0]
                                        })
                                    }
                                //}
                               
                                
                            });
                        } else {
                           
                             objViewData = data.data.ViewData.map(function (item) {
                                for (var key in item) {

                                    item[key.toLowerCase()] = item[key];
                                }
                                return item;
                             })

                            if (this.gridRef.current.instance.columnOption(Object.keys(objViewData[0])[0]) === undefined) {
                                this.gridRef.current.instance.addColumn(Object.keys(objViewData[0])[0], 'Data Field', Object.keys(objViewData[0])[0], 'Caption', Object.keys(objViewData[0])[0], 'visible', "false")
                            }
                            this.setState({

                                ViewData: objViewData,

                                keyExpr: Object.keys(objViewData[0])[0]
                            })
                        }
                       
                      
                        this.props.indicatorVisible(false)
                    }).catch(function (error) {
                        this.setState({ ViewData: [] })
                        this.props.indicatorVisible(false)
                        if (error == "TOKEN_REFRESH_EXCEPTION") {
                            alert('Your login session has expired, please log in again.')
                            window.location.href = '/';
                        }
                    }.bind(this));
            }
        }
    }
    modal = () => {

    }
    //(TM 29-01-19 ) Open right side bar
    opensidebar = () => {
        document.getElementById("mySidenav").style.width = "360px";
        document.getElementById("main").style.marginRight = "360px";
        document.getElementById("mySidenav").style.marginTop = "-47px";
        document.getElementById('btnMenu').style.visibility = 'hidden';
        document.getElementById('closemenu').style.visibility = 'visible';
    }
    //(TM 29-01-19 ) Close right side bar
    closesidebar = () => {
        document.getElementById("mySidenav").style.width = "0px";
        document.getElementById("main").style.marginRight = "0px";
        document.getElementById('btnMenu').style.visibility = 'visible';
        document.getElementById('closemenu').style.visibility = 'hidden';
        document.getElementById('btnMenu').style.marginTop = '-40px';
    }

    removeTab() {

        var newIdx = this.state.currentTabIdx === this.state.Tabs.length - 1 ? this.state.currentTabIdx - 1 : this.state.currentTabIdx

        this.state.Tabs.splice(this.state.currentTabIdx, 1)
        this.setState({
            currentTabIdx: newIdx,
            changeTab: true
        })

        this.props.setState(this.state.Tabs[newIdx].state)

        this.setState({ changeTab: false })
        //this.props.actionRemoveTab(true)
    }

    openTab() {

        const url = window.location.href + '?folderid=' + this.props.folderIdState
            + "&roleid=" + this.props.roledataId
            + "&taskid=" + this.props.taskIdState
            + "&dirid=" + this.props.directoryIdState
        window.open(url, '_blank');

    }

    changeResizingMode(data) {
        this.setState({ mode: data.value });
    }
    onSelectionChanged(e) {
       
        currRow = e.selectedRowsData

        this.props.currObjectSet(e.selectedRowKeys)
        this.props.currALLObjectSet(currRow)
    }

    onRowPrepared(e) {
        this.state.ViewDataPresentationConditions.forEach((item) => {
      

            var str = item.result.substring(2);
          
            var partsColours = str.match(/[\s\S]{1,2}/g) || [];
          
            if (item.operator === "<=") {
             
                if (e.rowType === 'data' && e.data[item.targetColumn.toLowerCase()] <= item.condition1) {
                   
                    if (item.result.length === 8) {
                   
                        e.rowElement.style.backgroundColor = '#' + partsColours[2] + partsColours[1] + partsColours[0];
                    } else if (item.result.length === 6) {
                     
                        e.rowElement.style.backgroundColor = '#' + partsColours[1] + partsColours[0] + '00';
                    } else {
                      
                        e.rowElement.style.backgroundColor = '#' + partsColours[0] + '00' + '00';
                    }
                    e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
                }
            }
            if (item.operator === "=") {
             
                if (e.rowType === 'data' && e.data[item.targetColumn.toLowerCase()] === item.condition1) {

                    if (item.result.length === 8) {
                      
                        e.rowElement.style.backgroundColor = '#' + partsColours[2] + partsColours[1] + partsColours[0];
                    } else if (item.result.length === 6) {
                     
                        e.rowElement.style.backgroundColor = '#' + partsColours[1] + partsColours[0] + '00';
                    } else {
                     
                        e.rowElement.style.backgroundColor = '#' + partsColours[0] + '00' + '00';
                    }
                       
                   
                   
                    e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
                }
            }
            if (item.operator === "<") {
 
                if (e.rowType === 'data' && e.data[item.targetColumn.toLowerCase()] < item.condition1) {
                    if (item.result.length === 8) {

                        e.rowElement.style.backgroundColor = '#' + partsColours[2] + partsColours[1] + partsColours[0];
                    } else if (item.result.length === 6) {

                        e.rowElement.style.backgroundColor = '#' + partsColours[1] + partsColours[0] + '00';
                    } else {

                        e.rowElement.style.backgroundColor = '#' + partsColours[0] + '00' + '00';
                    }
                    e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
                }
            }
            if (item.operator === ">") {

                if (e.rowType === 'data' && e.data[item.targetColumn.toLowerCase()] > item.condition1) {
                   
                   
                    if (item.result.length === 8) {

                        e.rowElement.style.backgroundColor = '#' + partsColours[2] + partsColours[1] + partsColours[0];
                    } else if (item.result.length === 6) {

                        e.rowElement.style.backgroundColor = '#' + partsColours[1] + partsColours[0] + '00';
                    } else {

                        e.rowElement.style.backgroundColor = '#' + partsColours[0] + '00' + '00';
                    }
                    e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
                }
            }
            if (item.operator === ">=") {

                if (e.rowType === 'data' && e.data[item.targetColumn.toLowerCase()] >= item.condition1) {
                   
                    if (item.result.length === 8) {

                        e.rowElement.style.backgroundColor = '#' + partsColours[2] + partsColours[1] + partsColours[0];
                    } else if (item.result.length === 6) {
 
                        e.rowElement.style.backgroundColor = '#' + partsColours[1] + partsColours[0] + '00';
                    } else {
          
                        e.rowElement.style.backgroundColor = '#' + partsColours[0] + '00' + '00';
                    }
                    e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
                }
            }
            if (item.operator === "<>") {

                if (e.rowType === 'data' && e.data[item.targetColumn.toLowerCase()] !== item.condition1) {
                    //e.rowElement.style.backgroundColor = '#' + item.result.substring(2).split("").reverse().join("");
                   // e.rowElement.style.backgroundColor = '#' + parts[2] + parts[1] + parts[0];
                    if (item.result.length === 8) {
     
                        e.rowElement.style.backgroundColor = '#' + partsColours[2] + partsColours[1] + partsColours[0];
                    } else if (item.result.length === 6) {
               
                        e.rowElement.style.backgroundColor = '#' + partsColours[1] + partsColours[0] + '00';
                    } else {
                
                        e.rowElement.style.backgroundColor = '#' + partsColours[0] + '00' + '00';
                    }
                    e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
                }
            }
            if (item.operator === "B") {
        
                if (e.rowType === 'data' && e.data[item.targetColumn.toLowerCase()] > item.condition1 && e.data[item.targetColumn.toLowerCase()] < item.condition2) {
                    //e.rowElement.style.backgroundColor = '#' + item.result.substring(2).split("").reverse().join("");
                   // e.rowElement.style.backgroundColor = '#' + parts[2] + parts[1] + parts[0];
                    if (item.result.length === 8) {
                   
                        e.rowElement.style.backgroundColor = '#' + partsColours[2] + partsColours[1] + partsColours[0];
                    } else if (item.result.length === 6) {
                     
                        e.rowElement.style.backgroundColor = '#' + partsColours[1] + partsColours[0] + '00';
                    } else {
                      
                        e.rowElement.style.backgroundColor = '#' + partsColours[0] + '00' + '00';
                    }
                    e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
                }
            }
            if (item.operator === "NB") {
            
                if (e.rowType === 'data' && e.data[item.targetColumn.toLowerCase()] < item.condition1 && e.data[item.targetColumn.toLowerCase()] > item.condition2) {
                    //e.rowElement.style.backgroundColor = '#' + item.result.substring(2).split("").reverse().join("");
                    //e.rowElement.style.backgroundColor = '#' + parts[2] + parts[1] + parts[0];
                    if (item.result.length === 8) {
                  
                        e.rowElement.style.backgroundColor = '#' + partsColours[2] + partsColours[1] + partsColours[0];
                    } else if (item.result.length === 6) {
                      
                        e.rowElement.style.backgroundColor = '#' + partsColours[1] + partsColours[0] + '00';
                    } else {
                      
                        e.rowElement.style.backgroundColor = '#' + partsColours[0] + '00' + '00';
                    }
                    e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
                }
            }
        })


    }

    tab = e => {
       
        this.props.actionDashboardlistset(this.props.taskcontextExpandCollapse)
       
       
        this.setState({
            currentTabIdx: e.itemIndex,
            changeTab: true
        })

        this.props.setState(this.state.Tabs[e.itemIndex].state)

        this.setState({ changeTab: false })
        this.props.actionTabsSet(true)
    }

    checkAvailability = () => {
        const type = 'success';
        const text = 'Copied to Clipboard';

        notify(text, type, 1600);
    }
    callbackFunction = (id, phase, actualDuration, baseDuration, startTime, commitTime, interaction) => {
        //console.log('id is:' + id + ',phase is:' + phase);
        //console.log('Actual Duration IS:' + actualDuration + ',BaseDuration is:' + baseDuration);
        //console.log('StartTime IS:' + startTime + ',commitTime is:' + commitTime);
        //console.log('interaction IS:' + interaction);
    }

    //error = (e) => {

    //    fetch(this.state.ViewDataViewDocumentPath)
    //        .then(function (response) {
    //            // Do stuff with the response
    //        })
    //        .catch(function (error) {
    //            console.log('Looks like there was a problem: ', error);
    //        });
       
    //}
    selectQR = (e) => {
        var url = window.location.href
      
    }
    render() {

        
        ViewDataViewDocumentPath: ''
       
        if (this.state.ViewDataViewDocumentPath !== null && this.state.ViewDataViewDocumentPath !== '') {
            var lastChar = this.state.ViewDataViewDocumentPath.substr(this.state.ViewDataViewDocumentPath.length - 4);
           
            if (lastChar === '.vbd') {
                urlstate = false
                
            } else {
                    urlstate = true
            }
        } else {
                urlstate = false
        }
        var widthResolution = window.innerWidth
        var browserZoomLevel;
        window.onresize = resize;
        function resize() {
            browserZoomLevel = Math.round(window.devicePixelRatio * 100);
        }
        var datagridHeight
        const { detect } = require('detect-browser');
        const browser = detect();

        // handle the case where we don't detect the browser
        
        if (browser.name === 'edge-chromium' || browser.name === 'chrome') {
           // console.log('edgechrome')
            if (this.state.windowSize >= 2880 && this.state.windowSize < 3200) {
                //console.log('this.state.windowSize >= 2752 && this.state.windowSize < 3200')
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 10) {
                        datagridHeight = '1216px'
                    } else if (actionsLength > 9 && actionsLength < 19) {
                        datagridHeight = '1180px'
                    } else if (actionsLength > 18 && actionsLength < 28) {
                        datagridHeight = '1050px'
                    }
                }
            }
            if (this.state.windowSize >= 2560 && this.state.windowSize < 2880) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 8) {
                        datagridHeight = '1050px'
                    } else if (actionsLength > 7 && actionsLength < 15) {

                        datagridHeight = '1017px'
                    } else if (actionsLength > 14 && actionsLength < 22) {
                        datagridHeight = '990px'
                    }
                }
            }
            if (this.state.windowSize >= 2520 && this.state.windowSize < 2560) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 8) {
                        datagridHeight = '1168px'
                    } else if (actionsLength > 7 && actionsLength < 15) {
                        datagridHeight = '1138px'
                    } else if (actionsLength > 14 && actionsLength < 22) {
                        datagridHeight = '990px'
                    }
                }
            }  
            if (this.state.windowSize >= 2400 && this.state.windowSize < 2520) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 8) {
                        datagridHeight = '956px'
                    } else if (actionsLength > 7 && actionsLength < 15) {
                        if (this.props.folderExpandCollapse === false && this.props.taskcontextExpandCollapse === false) {
                            datagridHeight = '973px'
                        } else {
                            datagridHeight = '942px'
                        }
                      
                    } else if (actionsLength > 14 && actionsLength < 22) {
                        datagridHeight = '888px'
                    }
                    else if (actionsLength > 21 && actionsLength < 33) {
                        datagridHeight = '854px'
                    }
                }
            }
            if (this.state.windowSize >= 2240 && this.state.windowSize < 2400) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 7) {
                        datagridHeight = '1014px'
                    } else if (actionsLength > 6 && actionsLength < 12) {
                        datagridHeight = '978px'
                    } else if (actionsLength > 11 && actionsLength < 17) {
                        if (this.props.taskcontextExpandCollapse === false) {
                            datagridHeight = '900px'
                        } else {
                            datagridHeight = '950px'
                        }
                        //datagridHeight = '760px'
                    }
                    else if (actionsLength > 16 && actionsLength < 22) {
                        datagridHeight = '650px'
                    }
                }
            }
            if (this.state.windowSize >= 2133 && this.state.windowSize < 2160) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (window.innerHeight < 1053) {
                        if (actionsLength < 7) {
                            datagridHeight = '798px'
                        } else if (actionsLength > 6 && actionsLength < 12) {
                            datagridHeight = '780px'
                        } else if (actionsLength > 11 && actionsLength < 17) {
                            if (this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '780px'
                            } else {
                                datagridHeight = '750px'
                            } 
                        }
                        else if (actionsLength > 16 && actionsLength < 22) {
                            datagridHeight = '560px'
                        }
                    } else {
                        if (actionsLength < 7) {
                            datagridHeight = '828px'
                        } else if (actionsLength > 6 && actionsLength < 12) {
                            datagridHeight = '808px'
                        } else if (actionsLength > 11 && actionsLength < 17) {
                            if (this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '810px'
                            } else {
                                datagridHeight = '760px'
                            }
                        }
                        else if (actionsLength > 16 && actionsLength < 22) {
                            datagridHeight = '590px'
                        }
                    }
                }
            }
            if (this.state.windowSize >= 2160 && this.state.windowSize < 2240) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 7) {
                        datagridHeight = '947px'
                    } else if (actionsLength > 6 && actionsLength < 12) {
                        datagridHeight = '914px'
                    } else if (actionsLength > 11 && actionsLength < 17) {
                        datagridHeight = '875px'
                    }
                    else if (actionsLength > 16 && actionsLength < 22) {
                        datagridHeight = '832px'
                    }
                }
            }
            if (this.state.windowSize >= 2100 && this.state.windowSize < 2133) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 7) {
                        datagridHeight = '916px'
                    } else if (actionsLength > 6 && actionsLength < 12) {
                        datagridHeight = '883px'
                    } else if (actionsLength > 11 && actionsLength < 17) {
                        datagridHeight = '852px'
                    }
                    else if (actionsLength > 16 && actionsLength < 22) {
                        datagridHeight = '832px'
                    }
                }
            }
            if (this.state.windowSize >= 1919 && this.state.windowSize < 2100) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (window.innerHeight > 950) {
                        if (actionsLength < 6) {
                            datagridHeight = '710px'
                        } else if (actionsLength > 5 && actionsLength < 11) {
                          
                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '681px'
                            } else {
                                datagridHeight = '678px'
                            }
                        } else if (actionsLength > 10 && actionsLength < 16) {
                            datagridHeight = '628px'
                        }
                        else if (actionsLength > 15 && actionsLength < 21) {
                            datagridHeight = '590px'
                        }
                    }
                    if (window.innerHeight < 950) {
                        if (actionsLength < 6) {
                          
                            datagridHeight = '687px'
                        } else if (actionsLength > 5 && actionsLength < 11) {
                           
                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '668px'
                            } else {
                                datagridHeight = '660px'
                            }

                        } else if (actionsLength > 10 && actionsLength < 16) {
                           
                            datagridHeight = '631px'
                        }
                        else if (actionsLength > 15 && actionsLength < 21) {
                           
                            datagridHeight = '590px'
                        }
                    }
                   
                }
               
            }
            if (this.state.windowSize >= 1866 && this.state.windowSize < 1919) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 6) {
                        datagridHeight = '799px'
                    } else if (actionsLength > 5 && actionsLength < 11) {
                        datagridHeight = '766px'
                    } else if (actionsLength > 10 && actionsLength < 16) {
                        datagridHeight = '734px'
                    }
                    else if (actionsLength > 15 && actionsLength < 21) {
                        datagridHeight = '590px'
                    }
                }
            }
            if (this.state.windowSize >= 1800 && this.state.windowSize < 1866) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {
                        datagridHeight = '708px'
                    } else if (actionsLength > 4 && actionsLength < 9) {
                        datagridHeight = '677px'
                    } else if (actionsLength > 8 && actionsLength < 13) {
                        datagridHeight = '639px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {
                        datagridHeight = '608px'
                    }
                }
            }
            if (this.state.windowSize >= 1777 && this.state.windowSize < 1800) {

                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {
                       
                        datagridHeight = '622px'
                    } else if (actionsLength > 4 && actionsLength < 9) {
                       
                        datagridHeight = '586px'
                    } else if (actionsLength > 8 && actionsLength < 13) {
                       
                        datagridHeight = '554px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {
                       
                        datagridHeight = '520px'
                    }
                }
            }
            if (this.state.windowSize >= 1745 && this.state.windowSize < 1777) {
               
                if (window.innerHeight < 830) {
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 5) {
                          
                            datagridHeight = '587px'
                        } else if (actionsLength > 4 && actionsLength < 9) {
                           
                            datagridHeight = '555px'
                        } else if (actionsLength > 8 && actionsLength < 13) {
                          
                            datagridHeight = '518px'
                        }
                        else if (actionsLength > 12 && actionsLength < 17) {
                           
                            datagridHeight = '485px'
                        }
                    }
                }
                else {
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 5) {
                           
                            datagridHeight = '610px'
                        } else if (actionsLength > 4 && actionsLength < 9) {
                           
                            datagridHeight = '574px'
                        } else if (actionsLength > 8 && actionsLength < 13) {
                          
                            datagridHeight = '541px'
                        }
                        else if (actionsLength > 12 && actionsLength < 17) {
                          
                            datagridHeight = '507px'
                        }
                    }
                }
                
            }
            if (this.state.windowSize >= 1680 && this.state.windowSize < 1745) {

               
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {
                       
                        datagridHeight = '700px'
                    } else if (actionsLength > 4 && actionsLength < 9) {
                      
                        datagridHeight = '663px'
                    } else if (actionsLength > 8 && actionsLength < 13) {
                      
                        datagridHeight = '628px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {
                       
                        datagridHeight = '596px'
                    }
                }
            }
            if (this.state.windowSize >= 1600 && this.state.windowSize < 1680) {
              
                if (window.innerHeight >= 775 && window.innerHeight < 876 ) {
                   
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 5) {
                          
                            datagridHeight = '540px'
                        } else if (actionsLength > 4 && actionsLength < 9) {
                           
                            datagridHeight = '506px'
                        } else if (actionsLength > 8 && actionsLength < 13) {
                           
                            datagridHeight = '472px'
                        }
                        else if (actionsLength > 12 && actionsLength < 17) {
                           
                            datagridHeight = '438px'
                        }
                    }
                }
                if (window.innerHeight >= 876) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {
                      
                        datagridHeight = '625px'
                    } else if (actionsLength > 4 && actionsLength < 9) {
                       
                        datagridHeight = '591px'
                    } else if (actionsLength > 8 && actionsLength < 13) {
                       
                        datagridHeight = '560px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {
                       
                        datagridHeight = '522px'
                    }
                }
                //if (window.innerHeight < 776) {
                //    console.log('window.innerHeight < 775')
                //    if (this.props.actionState != undefined) {
                //        var actionsLength = this.props.actionState.length
                //        if (actionsLength < 5) {
                //            console.log('11')
                //            datagridHeight = '526px'
                //        } else if (actionsLength > 4 && actionsLength < 9) {
                //            console.log('22')
                //            datagridHeight = '491px'
                //        } else if (actionsLength > 8 && actionsLength < 13) {
                //            console.log('33')
                //            datagridHeight = '457px'
                //        }
                //        else if (actionsLength > 12 && actionsLength < 17) {
                //            console.log('44')
                //            datagridHeight = '423px'
                //        }
                //    }
                //}
            }
            if (this.state.windowSize >= 1555 && this.state.windowSize < 1600) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 4) {
                      
                        datagridHeight = '795px'
                    } else if (actionsLength > 3 && actionsLength < 7) {
                        
                        datagridHeight = '761px'
                    } else if (actionsLength > 6 && actionsLength < 10) {
                      
                        datagridHeight = '727px'
                    }
                    else if (actionsLength > 9 && actionsLength < 13) {
                        
                        datagridHeight = '693px'
                    }
                    else if (actionsLength > 12 && actionsLength < 16) {
                       
                        datagridHeight = '657px'
                    }
                }
            }
            if (this.state.windowSize >= 1536 && this.state.windowSize < 1555) {
                if (window.innerHeight < 731) {
                    
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                           
                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '519px'
                            } else {
                                datagridHeight = '475px'
                            }
                           
                        } else if (actionsLength > 3 && actionsLength < 7) {
                           
                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '485px'
                            } else {
                                datagridHeight = '441px'
                            }
                          
                        } else if (actionsLength > 6 && actionsLength < 10) {
                           

                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '448px'
                            } else {
                                datagridHeight = '403px'
                            }

                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '417px'
                            } else {
                                datagridHeight = '373px'
                            }
                           
                           
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                           
                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '382px'
                            } else {
                                datagridHeight = '346px'
                            }
                           
                        }
                    }
                } else {
                   
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                           
                            datagridHeight = '604px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                           
                            datagridHeight = '493px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                          

                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '492px'
                            } else {
                                datagridHeight = '437px'
                            }

                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                           
                            datagridHeight = '425px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                           
                            datagridHeight = '390px'
                        }
                    }
                }
               
            }
            if (this.state.windowSize >= 1527 && this.state.windowSize < 1536) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 4) {
                      
                        datagridHeight = '600px'
                    } else if (actionsLength > 3 && actionsLength < 7) {
                       
                        datagridHeight = '569px'
                    } else if (actionsLength > 6 && actionsLength < 10) {
                       
                        datagridHeight = '535px'
                    }
                    else if (actionsLength > 9 && actionsLength < 13) {
                       
                        datagridHeight = '503px'
                    }
                    else if (actionsLength > 12 && actionsLength < 16) {
                       
                        datagridHeight = '467px'
                    }
                }
            }
            if (this.state.windowSize >= 1455 && this.state.windowSize < 1527) {
              
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 4) {
                       
                        datagridHeight = '470px'
                    } else if (actionsLength > 3 && actionsLength < 7) {
                     
                        datagridHeight = '435px'
                    } else if (actionsLength > 6 && actionsLength < 10) {
                       
                        datagridHeight = '404px'
                    }
                    else if (actionsLength > 9 && actionsLength < 13) {
                       
                        datagridHeight = '368px'
                    }
                    else if (actionsLength > 12 && actionsLength < 16) {
                      
                        datagridHeight = '335px'
                    }
                }
            }
            if (this.state.windowSize >= 1440 && this.state.windowSize < 1455) {
                if (window.innerHeight > 775) {
                    
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                           
                            datagridHeight = '527px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                          
                            datagridHeight = '490px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                           
                            datagridHeight = '456px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                           
                            datagridHeight = '420px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                           
                            datagridHeight = '390px'
                        }
                    }
                }
                if (window.innerHeight < 776) {
                   
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                          
                            datagridHeight = '527px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                          
                            datagridHeight = '490px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                           
                            datagridHeight = '456px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                           
                            datagridHeight = '420px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                          
                            datagridHeight = '390px'
                        }
                    }
                }
            }
            if (this.state.windowSize >= 1400 && this.state.windowSize < 1440) {
                if (window.innerHeight > 926) {
                   
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                           
                            datagridHeight = '675px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                           
                            datagridHeight = '639px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                           
                            datagridHeight = '605px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                           
                            datagridHeight = '566px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                          
                            datagridHeight = '535px'
                        }
                    }
                }
                
                if (window.innerHeight < 926) {
                   
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                           
                            datagridHeight = '675px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                           
                            datagridHeight = '639px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                           
                            datagridHeight = '605px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                           
                            datagridHeight = '566px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                           
                            datagridHeight = '535px'
                        }
                    }
                }
            }
            if (this.state.windowSize >= 1309 && this.state.windowSize < 1440) {
                if (this.props.actionState != undefined) {
                    if (window.innerHeight < 940) {
                        if (this.props.actionState != undefined) {
                            var actionsLength = this.props.actionState.length
                            if (actionsLength < 4) {
                              
                                datagridHeight = '675px'
                            } else if (actionsLength > 3 && actionsLength < 7) {
                               
                                datagridHeight = '639px'
                            } else if (actionsLength > 6 && actionsLength < 10) {
                               
                                datagridHeight = '605px'
                            }
                            else if (actionsLength > 9 && actionsLength < 13) {
                              
                                datagridHeight = '566px'
                            }
                            else if (actionsLength > 12 && actionsLength < 16) {
                              
                                datagridHeight = '535px'
                            }
                        }
                    } else {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                           
                            datagridHeight = '475px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                           
                            datagridHeight = '439px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                           
                            datagridHeight = '401px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                           
                            datagridHeight = '366px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                           
                            datagridHeight = '333px'
                        }
                    }
                    
                }
            }
            if (this.state.windowSize >= 1272 && this.state.windowSize < 1309) {
                var actionsLength = this.props.actionState.length
                if (actionsLength < 4) {
                   
                    datagridHeight = '560px'
                } else if (actionsLength > 3 && actionsLength < 7) {
                    
                    datagridHeight = '530px'
                } else if (actionsLength > 6 && actionsLength < 10) {
                    
                    datagridHeight = '464px'
                }
                else if (actionsLength > 9 && actionsLength < 13) {
                   
                    datagridHeight = '455px'
                }
                else if (actionsLength > 12 && actionsLength < 16) {
                    
                    datagridHeight = '423px'
                }
            }
        }
        if (browser.name === 'firefox') {
          
            if (this.state.windowSize >= 2752 && this.state.windowSize < 3200) {
              
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 9) {
                      
                        datagridHeight = '1127px'
                    } else if (actionsLength > 8 && actionsLength < 17) {
                     
                        datagridHeight = '1094px'
                    } else if (actionsLength > 16 && actionsLength < 25) {
                      
                        datagridHeight = '1050px'
                    }
                    
                }
            }
            if (this.state.windowSize >= 2400 && this.state.windowSize < 2752) {
               
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 8) {
                     
                        datagridHeight = '926px'
                    } else if (actionsLength > 7 && actionsLength < 15) {
                      
                        if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                            datagridHeight = '957px'
                        } else {
                            datagridHeight = '922px'
                        }
                        
                    } else if (actionsLength > 14 && actionsLength < 22) {
                     
                        datagridHeight = '888px'
                    }
                    else if (actionsLength > 21 && actionsLength < 33) {
                      
                        datagridHeight = '854px'
                    }
                }
            }
            if (this.state.windowSize >= 2144 && this.state.windowSize < 2400) {
               
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 7) {
                       
                        datagridHeight = '803px'
                    } else if (actionsLength > 6 && actionsLength < 12) {
                      
                        if (this.props.folderExpandCollapse === false && this.props.taskcontextExpandCollapse === false) {
                            datagridHeight = '830px'
                        } else {
                            datagridHeight = '796px'
                        }
                       
                    } else if (actionsLength > 11 && actionsLength < 17) {
                       
                        datagridHeight = '760px'
                    }
                    else if (actionsLength > 16 && actionsLength < 22) {
                      
                        datagridHeight = '590px'
                    }
                }
            }
            if (this.state.windowSize >= 2100 && this.state.windowSize < 2144) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 7) {
                       
                        datagridHeight = '916px'
                    } else if (actionsLength > 6 && actionsLength < 12) {
                       
                        datagridHeight = '883px'
                    } else if (actionsLength > 11 && actionsLength < 17) {
                      
                        datagridHeight = '852px'
                    }
                    else if (actionsLength > 16 && actionsLength < 22) {
                      
                        datagridHeight = '832px'
                    }
                }
            }
            if (this.state.windowSize >= 2064 && this.state.windowSize < 2100) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 6) {
                       
                        datagridHeight = '870px'
                    } else if (actionsLength > 5 && actionsLength < 11) {
                       
                        datagridHeight = '837px'
                    } else if (actionsLength > 10 && actionsLength < 16) {
                      
                        datagridHeight = '803px'
                    }
                    else if (actionsLength > 15 && actionsLength < 21) {
                        
                        datagridHeight = '749px'
                    }
                }
            }
            if (this.state.windowSize >= 1919 && this.state.windowSize < 2064) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (window.innerHeight > 950) {
                        if (actionsLength < 6) {
                            datagridHeight = '710px'
                        } else if (actionsLength > 5 && actionsLength < 11) {
                           
                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '681px'
                            } else {
                                datagridHeight = '678px'
                            }

                        } else if (actionsLength > 10 && actionsLength < 16) {
                           
                            datagridHeight = '644px'
                        }
                        else if (actionsLength > 15 && actionsLength < 21) {
                         
                            datagridHeight = '590px'
                        }
                    }
                    if (window.innerHeight < 950) {
                        if (actionsLength < 6) {
                            
                            datagridHeight = '687px'
                        } else if (actionsLength > 5 && actionsLength < 11) {
                          
                            if (this.props.folderExpandCollapse === false || this.props.taskcontextExpandCollapse === false) {
                                datagridHeight = '657px'
                            } else {
                                datagridHeight = '654px'
                            }

                        } else if (actionsLength > 10 && actionsLength < 16) {
                          
                            datagridHeight = '644px'
                        }
                        else if (actionsLength > 15 && actionsLength < 21) {
                         
                            datagridHeight = '590px'
                        }
                    }
                }
            }
            if (this.state.windowSize >= 1876 && this.state.windowSize < 1919) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length

                    if (actionsLength < 6) {
                      
                        datagridHeight = '789px'
                    } else if (actionsLength > 5 && actionsLength < 11) {
                       
                        datagridHeight = '756px'
                    } else if (actionsLength > 10 && actionsLength < 16) {
                       
                        datagridHeight = '724px'
                    }
                    else if (actionsLength > 15 && actionsLength < 21) {
                      
                        datagridHeight = '580px'
                    }
                }
            }
            if (this.state.windowSize >= 1800 && this.state.windowSize < 1876) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {
                       
                        datagridHeight = '708px'
                    } else if (actionsLength > 4 && actionsLength < 9) {
                      
                        datagridHeight = '677px'
                    } else if (actionsLength > 8 && actionsLength < 13) {
                      
                        datagridHeight = '639px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {
                      
                        datagridHeight = '608px'
                    }
                }
            }
            
            if (this.state.windowSize >= 1787 && this.state.windowSize < 1800) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {
                       
                        datagridHeight = '607px'
                    } else if (actionsLength > 4 && actionsLength < 9) {
                       
                        datagridHeight = '576px'
                    } else if (actionsLength > 8 && actionsLength < 13) {
                        
                        datagridHeight = '538px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {
                       
                        datagridHeight = '507px'
                    }
                }
            }
            if (this.state.windowSize >= 1756 && this.state.windowSize < 1787) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {
                        datagridHeight = '607px'
                    } else if (actionsLength > 4 && actionsLength < 9) {
                        datagridHeight = '574px'
                    } else if (actionsLength > 8 && actionsLength < 13) {
                        datagridHeight = '539px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {
                        datagridHeight = '507px'
                    }
                }
            }
            if (this.state.windowSize >= 1680 && this.state.windowSize < 1756) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {
                        datagridHeight = '680px'
                    } else if (actionsLength > 4 && actionsLength < 9) {

                        datagridHeight = '643px'
                    } else if (actionsLength > 8 && actionsLength < 13) {

                        datagridHeight = '608px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {

                        datagridHeight = '576px'
                    }
                }
            }
            if (this.state.windowSize >= 1608 && this.state.windowSize < 1680) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 5) {

                        datagridHeight = '617px'
                    } else if (actionsLength > 4 && actionsLength < 9) {

                        datagridHeight = '582px'
                    } else if (actionsLength > 8 && actionsLength < 13) {

                        datagridHeight = '550px'
                    }
                    else if (actionsLength > 12 && actionsLength < 17) {

                        datagridHeight = '515px'
                    }
                }
            }
            if (this.state.windowSize >= 1600 && this.state.windowSize < 1608) {
                

                if (window.innerHeight > 775) {

                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 5) {

                            datagridHeight = '547px'
                        } else if (actionsLength > 4 && actionsLength < 9) {

                            datagridHeight = '513px'
                        } else if (actionsLength > 8 && actionsLength < 13) {

                            datagridHeight = '479px'
                        }
                        else if (actionsLength > 12 && actionsLength < 17) {

                            datagridHeight = '445px'
                        }
                    }
                }
                if (window.innerHeight < 776) {

                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 5) {

                            datagridHeight = '526px'
                        } else if (actionsLength > 4 && actionsLength < 9) {

                            datagridHeight = '491px'
                        } else if (actionsLength > 8 && actionsLength < 13) {

                            datagridHeight = '457px'
                        }
                        else if (actionsLength > 12 && actionsLength < 17) {

                            datagridHeight = '423px'
                        }
                    }
                }
            }
            if (this.state.windowSize >= 1540 && this.state.windowSize < 1600) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 4) {
               
                        datagridHeight = '595px'
                    } else if (actionsLength > 3 && actionsLength < 7) {
                 
                        datagridHeight = '564px'
                    } else if (actionsLength > 6 && actionsLength < 10) {
                       
                        datagridHeight = '530px'
                    }
                    else if (actionsLength > 9 && actionsLength < 13) {
                      
                        datagridHeight = '493px'
                    }
                    else if (actionsLength > 12 && actionsLength < 16) {
                    
                        datagridHeight = '462px'
                    }
                }
            }
            if (this.state.windowSize >= 1467 && this.state.windowSize < 1540) {
                if (this.props.actionState != undefined) {
                    var actionsLength = this.props.actionState.length
                    if (actionsLength < 4) {
                 
                        datagridHeight = '465px'
                    } else if (actionsLength > 3 && actionsLength < 7) {
                     
                        datagridHeight = '428px'
                    } else if (actionsLength > 6 && actionsLength < 10) {
                      
                        datagridHeight = '395px'
                    }
                    else if (actionsLength > 9 && actionsLength < 13) {
                 
                        datagridHeight = '362px'
                    }
                    else if (actionsLength > 12 && actionsLength < 16) {
                   
                        datagridHeight = '328px'
                    }
                }
            }
            if (this.state.windowSize >= 1440 && this.state.windowSize < 1467) {
                if (window.innerHeight > 775) {
                
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                           
                            datagridHeight = '527px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                           
                            datagridHeight = '493px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                         
                            datagridHeight = '456px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                          
                            datagridHeight = '425px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                      
                            datagridHeight = '390px'
                        }
                    }
                }
                if (window.innerHeight < 776) {
                    
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                           
                            datagridHeight = '527px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                           
                            datagridHeight = '490px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                         
                            datagridHeight = '456px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                
                            datagridHeight = '420px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                    
                            datagridHeight = '390px'
                        }
                    }
                }
            }
            if (this.state.windowSize >= 1400 && this.state.windowSize < 1440) {
                if (window.innerHeight > 926) {
                
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                       
                            datagridHeight = '527px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                         
                            datagridHeight = '493px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                        
                            datagridHeight = '456px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                   
                            datagridHeight = '425px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                        
                            datagridHeight = '390px'
                        }
                    }
                }
                if (window.innerHeight < 926) {
             
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                         
                            datagridHeight = '675px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                          
                            datagridHeight = '639px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                    
                            datagridHeight = '605px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                        
                            datagridHeight = '566px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                        
                            datagridHeight = '535px'
                        }
                    }
                }
                if (window.innerHeight > 770 && window.innerHeight < 870) {
               
                    if (this.props.actionState != undefined) {
                        var actionsLength = this.props.actionState.length
                        if (actionsLength < 4) {
                         
                            datagridHeight = '500px'
                        } else if (actionsLength > 3 && actionsLength < 7) {
                           
                            datagridHeight = '489px'
                        } else if (actionsLength > 6 && actionsLength < 10) {
                          
                            datagridHeight = '450px'
                        }
                        else if (actionsLength > 9 && actionsLength < 13) {
                    
                            datagridHeight = '400px'
                        }
                        else if (actionsLength > 12 && actionsLength < 16) {
                      
                            datagridHeight = '300px'
                        }
                    }
                }
            }
        }
       
        

        var defaultPagesize
        var allowPagesize = []
        var enable
        var alowPages = []

        if (this.state.ViewData.length <= 50) {
            enable = false
            // alowPages = [20]
        }
        if (this.state.ViewData.length >= 101) {
            alowPages = [500, 1000, 5000]
            defaultPagesize = 200
            enable = true

        } else {
            enable = true
            defaultPagesize = 200

        }


        if (this.props.taskNameState !== undefined) {
            taskName = this.props.taskNameState

            if (taskName !== null) {

                var res = taskName.replace("<b style=font-weight:600>", "");
                taskname = res.replace("</b>", "");
            } else {

                taskname = this.props.taskNameState
            }


        }
        var taskNotificationCount = ''
        var folderkNotificationCount = ''

        if (this.props.folderNotifications !== undefined && this.props.folderNotifications > 0) {
            folderkNotificationCount = '(' + this.props.folderNotifications + ')'
        }


        if (this.props.taskNotifications !== undefined && this.props.taskNotifications > 0) {
            taskNotificationCount = '(' + this.props.taskNotifications + ')'
        }
       
     
        return (


            <div id="mySidenavfooter" className="sidenavfooter" >
                <div id="workPlaceArea" className="content-wrapper" style={{ backgroundColor: '#fff', fontSize: '13px' }}>
                    <div className="container" style={{ marginTop: 0 }}></div>
                    <div id="main">
                        <div className="menuIcon" style={{ fontSize: '20px' }}>
                            {/*<button id="closemenu" style={{ cursor: 'pointer', marginLeft: '-50px', marginTop: '75px' }} className="closebtn" onClick={this.closesidebar}> <SvgExpandCollapseRight /></button>*/}
                        </div>
                        <div className="menuIcon" style={{ marginTop: '-16px', marginRight: '9px' }}>
                            <span className="open" style={{ fontSize: '20px', cursor: 'pointer', marginTop: '-28px' }} id="btnMenu"></span>
                        </div>
                        <section className="content-header" style={{ marginTop: '101px' }}>
                            <h1 style={{ fontSize: '12px', textShadow: 'none', marginLeft: '-10px', color: '#1c1c1c' }}>
                                {
                                    this.props.taskNameState !== undefined &&
                                    <SvgEllipse />
                                }
                                <span
                                    style={{ borderRight: '0px solid #4d4d4d', paddingRight: '10px', paddingLeft: '10px', paddingBottom: '0px', paddingTop: '0px', fontFamily:'Roboto Condensed' }}
                                >
                                    {
                                        this.props.taskNameState !== undefined &&
                                        taskname + taskNotificationCount
                                    }
                                </span>
                                {
                                    this.props.contextSelectionState !== undefined &&
                                    this.props.contextSelectionState !== null &&
                                    this.props.rootContextState !== '00000000-0000-0000-0000-000000000000' &&
                                    this.props.contextSelectionState !== '00000000-0000-0000-0000-000000000000' &&
                                    this.props.rootSelectedState !== true &&
                                    <span
                                        style={{ borderLeft: '1px solid #6f7e95', borderRight: '0px solid #4d4d4d', paddingLeft: '10px', paddingRight: '10px', paddingBottom: '0px', paddingTop: '0px', fontFamily: 'Roboto Condensed' }}
                                    >
                                        {

                                            this.props.contextSelectionState.reduce((p, c) => `${p}${c.text} , `, "").slice(0, -2)
                                        }
                                    </span>
                                }
                                {
                                    this.props.folderNameState !== undefined && this.props.folderNameState !== null &&
                                    <span
                                        style={{ borderLeft: '1px solid #6f7e95', borderRight: '0px solid #4d4d4d', paddingLeft: '10px', paddingRight: '2px', paddingBottom: '0px', paddingTop: '0px', fontFamily: 'Roboto Condensed' }}
                                    >
                                        {
                                            this.props.folderNameState + folderkNotificationCount
                                        }
                                    </span>
                                }
                                {
                                    this.state.ViewData.length > 0 &&
                                    <span style={{ color: '#E41C59' }}>
                                        (
                                            {
                                            this.state.ViewData.length

                                        } Items)
                                </span>
                                }
                            </h1>

                            {/*<ActionsFab />*/}

                            <section style={{ marginTop: '5px', marginBottom: 7 }}>
                                
                                <div className={'dx-field'}>
                                    <div className={'dx-field-value'} style={{ display: 'inline-flex', marginLeft: '-18px' }}>

                                        <Button
                                            icon={open}
                                            height={30}
                                            marginLeft={11}
                                            width={70}
                                            marginTop={4}
                                            style={{ zIndex: '1' }}
                                            text={'Open'}
                                            type={'normal'}
                                            visible={this.state.Tabs.length > 0 ? true : false}
                                            disabled={this.state.Tabs.length > 1 ? false : true}
                                            stylingMode={'contained'}
                                            onClick={this.openTab.bind(this)} />
                                        <Button
                                            // icon="fa fa-minus"
                                            style={{ zIndex: '1' }}
                                            icon={remove}
                                            width={90}
                                            height={30}
                                            marginRight={11}
                                            marginTop={4}
                                            text={'Remove'}
                                            type={'normal'}
                                            visible={this.state.Tabs.length > 0 ? true : false}
                                            disabled={this.state.Tabs.length > 1 ? false : true}
                                            onClick={this.removeTab.bind(this)} />

                                        
                                        <div>
                                    </div>
                                   
                                        {/*
                                            this.props.useCache &&
                                            <button style={{ marginTop: '0px', float: 'right' }} onClick={this.getFolderData.bind(this, false)}>
                                                <UpdateWorkplace />
                                            </button>
                                        */}
                                        <div style={{ marginTop:'-3px', border: '0px solid #111', marginLeft: '72%', width: '180px', cursor: 'pointer' }}>
                                            {/*<span onClick={this.selectQR.bind(this)}
                                                style={{
                                                }}>
                                                <SvgQRIcon /> Generate QR Code
                                            </span>*/}
                                        </div>
                                        <CopyToClipboard style={{ width:'98px', border: '0px solid #111', marginTop: '0px', float: 'right', marginRight: '-5px', marginTop: '-18px', fontSize: '13px' }}
                                            text={window.location.href + '?folderid=' + this.props.folderIdState
                                                + "&roleid=" + this.props.roledataId
                                                + "&taskid=" + this.props.taskIdState
                                                + "&dirid=" + this.props.directoryIdState}>
                                            <button onClick={this.checkAvailability.bind(this)}>
                                                <WorkplaceClipboard />
                                            </button>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </section>
                        </section>

                        <TabPanel
                            width={'100%'}
                            style={{ paddingLeft: '9px' }}
                            scrollByContent={true}
                            showNavButtons={true}
                            noDataText={"No data to display"}
                            selectedIndex={this.state.currentTabIdx}
                            visible={this.state.Tabs.length > 0 ? true : false}>
                            {
                                this.state.Tabs.map(i => {
                                    return <Item title={i.display} onClick={this.tab} />
                                })
                            }
                        </TabPanel>
                        <div style={{ height: 'auto' }}>
                            {
                                urlstate === false ? (
                                  //alert('mpika')
                                //this.state.ViewDataConfigurationNoduplicates.length > 0 &&
                                (this.state.ViewData.length > 0 || this.state.ViewColumns.length > 0) &&
                               
                                <Profiler id="datagrid" onRender={this.callbackFunction}>
                                    
                                    <DataGrid
                                        //style={{ marginLeft:'-13px' }}
                                        onRowPrepared={this.onRowPrepared.bind(this.state.ViewDataPresentationConditions)}
                                        dataSource={this.state.ViewData}
                                        showBorders={false}
                                        allowColumnReordering={true}
                                        allowColumnResizing={true}
                                        columnResizingMode={'nextColumn'}
                                        columnMinWidth={30}

                                        autoNavigateToFocusedRow={true}
                                        focusedRowEnabled={true}
                                        //focusedRowKey={this.props.currentObjectIdState !== undefined && this.props.currentObjectIdState !== [] ? this.props.currentObjectIdState[0] : null}
                                        columnAutoWidth={true}
                                        showColumnLines={false}
                                        showRowLines={false}
                                        rowAlternationEnabled={true}
                                        onSelectionChanged={this.onSelectionChanged}
                                        width={'100%'}
                                        keyExpr={this.state.keyExpr}
                                        //height={datagridHeight}
                                        height={datagridHeight}
                                        ref={this.gridRef}>                                        
                                        <HeaderFilter visible={true} />
                                        <SearchPanel visible={true} />
                                        <Grouping autoExpandAll={true} /> 
                                        <Scrolling mode="standard" showScrollbar="always" useNative={true} />
                                        <Export style={{ marginTop: '-24px' }} enabled={true} fileName={'selectedrow'} allowExportSelectedData={true} />
                                        <FilterRow visible={true} />
                                        <Selection mode="single"//multiple single
                                            selectAllMode={'allPages'}
                                            showCheckBoxesMode={'always'}
                                        />

                                        <Sorting mode='multiple' />
                                        <Paging defaultPageSize={defaultPagesize} />
                                        <Pager
                                            visible={enable}
                                            showPageSizeSelector={true}
                                            allowedPageSizes={alowPages}
                                            showInfo={true} />
                                        <GroupPanel visible={true} />
                                        <ColumnFixing enabled={false} />
                                        {

                                            this.state.ViewColumns.length > 0 &&
                                            this.state.ViewColumns
                                        }
                                    </DataGrid>

                                    </Profiler>) : (

                                         <iframe style={{ border: 'none', width: '100%', height: datagridHeight, paddingTop: '20px' }} id='frame' src={this.state.ViewDataViewDocumentPath } onLoad={this.error} />
                                    )

                                    
                               
                            }
                        </div>
                        <div style={{ height: 'auto' }}>
                            <ActionsTA currRow={currRow} workplaceData={this.state.ViewData} />
                        </div>
                        <div id="Modal" class="modalDashboard">

                            <DashboardList onclick={this.Modal} actionID={this.onRefreshDashboard} />
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        usedataState: state.userData,
        taskIdState: state.taskDataId,
        contextTemplateIdState: state.contextTemplateDataId,
        contextSelectionState: state.contextSelection,
        roledataId: state.roleDataId,
        taskNameState: state.taskDataName,
        folderIdState: state.folderDataId,
        folderNameState: state.folderDataName,
        contextSelectionIdState: state.contextIdSelection,
        directoryIdState: state.directoryDataId,
        directoryNameState: state.directoryDataName,
        currentObjectIdState: state.currentObjectID,
        reduxState: state,
        contextConfig: state.currentContextConfiguration,
        actionMessage: state.currentActionmessage,
        themeState: state.currentThemeName,
        footerState: state.currFooterState,
        dashboardlist: state.currDashboardlistState,
        taskNotifications: state.currTaskNotificationState,
        folderNotifications: state.currFolderNotificationState,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        folderExpandCollapse: state.currFolderExpandCollapse,
        dashboardlist: state.currDashboardlistState,
        rootContextState: state.rootContext,
        rootSelectedState: state.rootSelected,
        multirootContext: state.currentActionmultiroot,
        windowpopupState: state.windowpopup,
        actionState: state.taaction,
     

    }
};

const mapDispatchToProps = dispatch => {
    return {
        setState: payload => dispatch(setStateAction(payload)),
        currObjectSet: payload => dispatch(setCurrentObjectId(payload)),
        currALLObjectSet: payload => dispatch(setCurrentObject(payload)),
        actionMessageset: payload => dispatch(setActionMessage(payload)),
        actionDashboardlistset: payload => dispatch(setActionDashboardlist(payload)),
        currFooterSet: payload => dispatch(setCurrentFooterAction(payload)),
        actionFolderNotificationset: payload => dispatch(setActionFolderNotifications(payload)),
        currTaskNotificationStateSet: payload => dispatch(setActionTaskNotifications(payload)),
        contextSelectionSet: payload => dispatch(setSelectedContextItemsAction(payload)),
        actionTaskContextExpandCollapse: payload => dispatch(setActionTaskContextExpColaps(payload)),
        actionFolderExpandCollapse: payload => dispatch(setActionFolderExpColaps(payload)),
        rootSelectedSet: payload => dispatch(setActionisrootSelected(payload)),
        actionTabsSet: payload => dispatch(setActionTabs(payload)),
        //actionRemoveTab: payload => dispatch(setActionRemoveTab(payload))



    }
}
export default connect(mapStateToProps, mapDispatchToProps)(WorkPlace);


// WEBPACK FOOTER //
// ./src/components/TaskView/WorkPlace/WorkPlace.js